import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const getWarehouseStaffId = createAction(ACTION.GET_WAREHOUSE_STAFF_ID.REQUEST, data => data);
export const editWarehouseStaff = createAction(ACTION.UPDATE_WAREHOUSE_STAFF.REQUEST, data => data);
export const clearState = createAction(ACTION.CLEAR_STATE);